export function DetailsIcon() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="18" fill="black" fillOpacity="0.15" />
      <path
        d="M23 24.43H19L14.55 27.39C13.89 27.83 13 27.36 13 26.56V24.43C10 24.43 8 22.43 8 19.43V13.4299C8 10.4299 10 8.42993 13 8.42993H23C26 8.42993 28 10.4299 28 13.4299V19.43C28 22.43 26 24.43 23 24.43Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9998 17.3599V17.1499C17.9998 16.4699 18.4198 16.1099 18.8398 15.8199C19.2498 15.5399 19.6598 15.1799 19.6598 14.5199C19.6598 13.5999 18.9198 12.8599 17.9998 12.8599C17.0798 12.8599 16.3398 13.5999 16.3398 14.5199"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9955 19.75H18.0045"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
